import { DateTime } from "luxon";

import { client } from "./api-client";
import { DATE_MEDIUM } from "./dates";

export type CashDrawerStatus = "OPEN" | "CLOSED";

export type CashDrawerApi = {
  id: number;
  sessionId: string;
  name?: string;
  startDate: string;
  status: CashDrawerStatus;
};

export class CashDrawer {
  readonly id: number;
  readonly sessionId: string;
  readonly name: string;
  readonly status: CashDrawerStatus;
  private readonly startDate: DateTime;

  constructor(
    id: number,
    sessionId: string,
    name: string | undefined,
    status: CashDrawerStatus,
    startDate: DateTime,
  ) {
    this.id = id;
    this.sessionId = sessionId;
    this.name = name ?? "Caja";
    this.status = status;
    this.startDate = startDate;
  }

  getStartDate() {
    return this.startDate.toLocaleString(DATE_MEDIUM);
  }
}

export const cashDrawerFromJson = (data: CashDrawerApi) =>
  new CashDrawer(data.id, data.sessionId, data.name, data.status, DateTime.fromISO(data.startDate));

export type OpenInput = { name?: string; initialAmount: number };

async function open(pos: "BACKOFFICE" | number | undefined, data: OpenInput) {
  if (pos === "BACKOFFICE") throw new Error("invalid operation");
  if (!pos) throw new Error("invalid POS");

  return await client<CashDrawerApi>(`api/pos/${pos}/cashDrawers`, { data }).then(
    cashDrawerFromJson,
  );
}

export type CloseInput = { closedDrawerAmount: number; sessionId: string };

async function close(
  pos: "BACKOFFICE" | number | undefined,
  { closedDrawerAmount, sessionId }: CloseInput,
) {
  if (pos === "BACKOFFICE") throw new Error("invalid operation");
  if (!pos) throw new Error("invalid POS");

  return await client(`api/pos/${pos}/cashDrawers/${sessionId}/close`, {
    data: { closedDrawerAmount },
  });
}

export { open, close };
